import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import CurrencyColumn from '../../../components/columns/currency-column';
import { USD } from '../../../constants/currency-codes';
import Global from '../../../store/global-selectors';
import { messages } from '../messages';

const RefundAmountRequestedColumn = ({ fulfillmentId }) => {
  const fulfillment = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const { refundAmountRequested } = fulfillment;

  if (!refundAmountRequested) {
    return '';
  }

  return <CurrencyColumn currencyCode={USD} value={refundAmountRequested} />;
};

RefundAmountRequestedColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const RefundAmountRequested = {
  getMessageDescriptor: () => messages.refundAmountRequested,
  id: 'refund-amount-requested',

  render: (data) => {
    if (!data) {
      return '';
    }
    return <RefundAmountRequestedColumn fulfillmentId={data.id} />;
  },
};
